import type { Router } from 'vue-router'
import { documentExistsById, getDocumentById } from '@/store/getters'
import type { DocumentType } from '@/types'

// Sous-ensemble volontaire de DocumentType : seuls ces types ont une transition
// slide dédiée, les autres retombent sur un simple fade.
const SLIDE_TYPES = new Set<DocumentType>([
  'text',
  'multimedia',
  'factcheck',
  'webstory'
])

export default function useHistoryState(router: Router) {
  router.afterEach((to, from) => {
    if (history.state.columnId) {
      to.meta.columnId = history.state.columnId
    }
    const docId =
      'docId' in to.params && typeof to.params.docId === 'string'
        ? to.params.docId
        : undefined
    if (!docId) return
    if (!from.name) {
      // Navigation initiale (redémarrage de l'app) : pas d'animation d'apparition
      to.meta.transition = undefined
      return
    }
    // getDocumentById lève une erreur sur un document absent du store (ouvert depuis le chat, par exemple)
    const doc = documentExistsById(docId) ? getDocumentById(docId) : undefined
    if (doc && SLIDE_TYPES.has(doc.type)) {
      const direction =
        typeof history.state.direction === 'string'
          ? history.state.direction
          : 'left'
      to.meta.transition = `slide-${direction}`
    } else {
      to.meta.transition = 'fade'
    }
  })
}
